import { Content, Value, Last } from './multi-input-value.styled';

export const MultiInputValue = (props) => {
  const { values, minWidth, placeholder } = props;

  /**
   * get displayed value
   * @returns
   */
  const getValue = () => {
    let out = '';
    const cnt = values.length;

    for (let i = 0; i < cnt; i++) {
      const item = values[i];
      // if (i >= maxValues) {
      //   break;
      // }
      if (out) {
        out += ', ';
      }
      out += item.name;
    }
    let last = cnt; // - maxValues;
    if (last < 0) {
      last = 0;
    }
    return { value: out, last };
  };

  const { value, last } = getValue();
  const title = values.map((el) => el.name).join(', ');

  return (
    <Content minWidth={minWidth} title={title}>
      <Value>{value ? value : (placeholder ?? 'Все')}</Value>
      {!!last && <Last>{last}</Last>}
    </Content>
  );
};
